import { AnyRoute, createRoute, lazyRouteComponent } from '@tanstack/react-router'

export const QRDetailsRoute = <T extends AnyRoute>(indexRoute: T) =>
  createRoute({
    getParentRoute: () => indexRoute,
    path: `$id`,
    component: lazyRouteComponent(() => import('./QRDetails'))
  })
